import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import Swiper, { Navigation, FreeMode } from 'swiper'
import 'swiper/css'

Swiper.use([Navigation, FreeMode])

export default function() {
  const sections = document.querySelectorAll('.swipe-section')
  const cursor = document.querySelector('.slider-cursor')

  sections.forEach(section => {
    const slider = new Swiper(section.querySelector('.swipe-slider'), {
      speed: 500,
      slidesPerView: 1.3,
      freeMode: true,
      centeredSlidesBounds: true,
      centeredSlides: true,
      watchSlidesProgress: true,

      breakpoints: {
        '1024': {
          slidesPerView: 'auto',
          centeredSlidesBounds: false,
          centeredSlides: false,
        },
      },
      on: {
        slideChangeTransitionStart: showSlide,

        touchStart() {
          cursor.classList.add('drag')
        },
        touchEnd() {
          cursor.classList.remove('drag')
        },
      },
    })

    ScrollTrigger.create({
      trigger: section.querySelector('.swipe-slide'),
      start: 'center bottom',
      end: 'center bottom',
      once: true,
      markers: false,
      onEnter: () => {
        showSlide()
      },
    })

    function showSlide() {
      // If the slide was shown before, remove this slide from the array
      const slides = slider.visibleSlides.filter(
        slide => !slide.classList.contains('show')
      )

      slides.forEach((slide, index) => {
        const imgFade = slide.querySelector('.swipe-slide__img-fade')
        const img = slide.querySelector('.swipe-slide__img')
        const num = slide.querySelectorAll('.swipe-slide__num .fade-el')
        const eyebrow = slide.querySelectorAll('.swipe-slide__eyebrow .fade-el')
        const title = slide.querySelectorAll('.swipe-slide__title .fade-el')
        const price = slide.querySelectorAll('.swipe-slide__price .fade-el')
        const arrow = slide.querySelector('.swipe-slide__arrow')

        const delayIndex = index * 0.25

        gsap
          .timeline({
            delay: delayIndex,
          })
          .to(imgFade, {
            transform: 'none',
            opacity: 1,
            duration: 0.6,
          })
          .to(
            img,
            {
              scale: 1,
              duration: 1,
            },
            '<'
          )
          .to(
            [...eyebrow, ...num, ...title, ...price],
            {
              transform: 'none',
              opacity: 1,
              stagger: 0.1,
              duration: 0.6,
            },
            '<0.3'
          )
          .call(
            () => {
              gsap.effects.animateArrowDiagonal(arrow, { duration: 0.6 })
            },
            null,
            '<0.2'
          )
          .call(() => slide.classList.add('show'), null, '<0.2')
      })
    }
  })
}
